
import { hPost, fetchHornConfig } from '@mcfe/tools';

export const API_LIST = {
    //  供应商当前入驻状态接口
    GET_MERCHANT_STATE: '/api/vss/shepherd/sqm/merchantsSupplier/getMerchantState',
    // 入驻详情信息查询接口
    MERCHANT_SUPPLIER_DETAIL: '/api/vss/shepherd/sqm/merchantsSupplier/detail',
    // 保存入驻信息提交接口
    SAVE_SUPPLIER: '/api/vss/shepherd/sqm/merchantsSupplier/saveInfo',
    // 查询供应商能够搜索的SKU
    SEARCH_SKU: '/api/vss/shepherd/supplier/merchants/search/sku',
};

export const getMerchantStateApi = (params) => hPost(API_LIST.GET_MERCHANT_STATE, params);

export const getMerchantsSupplierDetailApi = async (params) => hPost(API_LIST.MERCHANT_SUPPLIER_DETAIL, params);

export const saveMerchantsSupplierApi = async (params) => hPost(API_LIST.SAVE_SUPPLIER, params);

export const getSupplierSkuApi = async (params) => hPost(API_LIST.SEARCH_SKU, params);

// 获取授权联系人证明模版
export const getIdentifyCertApi = async () => {
    const tempalte = await fetchHornConfig('vss')('supplierRecruitmenTemplate');
    return tempalte;
};
